import types from "../index";
import subscriptions from "../../data/products";

export const defaultState = {
    user_id: null,
    user: null,
    token: null,
    subscription: null,
    history: null,
}

function dashboardReducer(state, action) {
    switch (action.type) {
        case types.DASHBOARD_SET_USER: {
            return {
                ...state,
                user: action.user,
            }
        }
        case types.DASHBOARD_SET_USER_ID: {
            return {
                ...state,
                user_id: action.id,
            }
        }
        case types.DASHBOARD_SET_SUBSCRIPTION: {
            return {
                ...state,
                subscription: action.subscription
            }
        }
        case types.DASHBOARD_LOAD_HISTORY: {
            return {
                ...state,
                history: action.history,
            }
        }

        default:
            throw new Error("Unhandled action type: " + action.type);
    }
}

export default dashboardReducer;
